import {
  VERIFY_AWARD_NOMINATION_PAYMENT_REQUEST,
  VERIFY_AWARD_NOMINATION_PAYMENT_SUCCESS,
  VERIFY_AWARD_NOMINATION_PAYMENT_FAILURE,
  VERIFY_AWARD_NOMINATION_PAYMENT_RESET,
} from "../../../types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const verifyAwardNominationPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_AWARD_NOMINATION_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case VERIFY_AWARD_NOMINATION_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case VERIFY_AWARD_NOMINATION_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.error,
        success: false,
      }

    case VERIFY_AWARD_NOMINATION_PAYMENT_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default verifyAwardNominationPaymentReducer
